



















import {
  Component,
  Vue,
  Emit,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import Loader from "@/components/Loader.vue";
import { formatService } from "../../services/format.service";
import { IProperty } from "../../models/interfaces/property/property.model.interface";
import { ICreativeOverview } from "../../models/interfaces/overview/creative-overview.model.interface";

const PropertyPerformanceModule = namespace("propertyPerformanceModule");
const PublisherModule = namespace("publisherModule");
const UserSelectionModule = namespace("userSelectionModule");
const CreativeEnquiryModule = namespace("creativeEnquiryModule");

@Component({
  components: {
    Loader
  }
})
export default class PropertyTemplatePerformanceTable extends Vue {
  @PropertyPerformanceModule.Action public retrievePropertyTemplatePerformance;
  @PropertyPerformanceModule.Getter public propertyTemplatePerformance;
  @UserSelectionModule.Getter public selectedDates;
  @PublisherModule.Getter public selectedProperty: IProperty | null;
  @CreativeEnquiryModule.Getter public creativeOverview;
  @CreativeEnquiryModule.Getter public creativeEnquiriesLoaded;
  @CreativeEnquiryModule.Action public retrieveCreativeEnquiryPerformance;

  @Provide() public currentPage = 1;
  @Provide() public perPage = 10;
  @Provide() public totalRows = 0;

  get showPagination(): boolean {
    return this.items.length > this.perPage;
  }

  public getRowCount(items) {
    return items.length;
  }

  get getSelectedProperty(): IProperty | null {
    return this.selectedProperty;
  }

  get getPerformanceData(): ICreativeOverview[] {
    return this.creativeOverview;
  }

  get getEnquiriesLoaded(): boolean {
    return this.creativeEnquiriesLoaded;
  }

  get getDates(): Date {
    return this.selectedDates;
  }

  @Prop({ default: "Table" })
  public caption: string;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: false })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: false })
  public fixed: boolean;

  @Prop({ default: false })
  public revenueAccess!: boolean;

  @Provide() public property: IProperty | null = null;

  @Provide() public items: ICreativeOverview[] = [];

  @Provide() public enquiriesLoaded: boolean = false;

  @Provide()
  public columns = [
    {
      key: "performance.name",
      label: "Creative",
      sortable: true
    },
    {
      key: "performance.loads",
      label: "Loads",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumber(value);
      }
    },
    {
      key: "performance.impressions",
      label: "Impressions",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.performance.impressions,
          item.performance.loads
        );
      }
    },
    {
      key: "performance.keyPresses",
      label: "Engagements",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.performance.keyPresses,
          item.performance.impressions
        );
      }
    },
    {
      key: "performance.clicks",
      label: "Clicks",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.performance.clicks,
          item.performance.impressions
        );
      }
    },
    {
      key: "enquiry.enquiries",
      label: "Enquiries",
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.enquiry.enquiries,
          item.performance.clicks
        );
      },
      class: this.revenueAccess ? "" : "d-none"
    },
    {
      key: "enquiry.conversions",
      label: "Converted",
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.enquiry.conversions,
          item.enquiry.enquiries
        );
      },
      class: this.revenueAccess ? "" : "d-none"
    },
    {
      key: "enquiry.revenue",
      label: "Revenue",
      formatter: (value, key, item) => {
        return formatService.formatCurrency(value);
      },
      class: this.revenueAccess ? "" : "d-none"
    }
  ];

  private loading: boolean = true;

  @Watch("getSelectedProperty")
  public onSelectedPropertyChanged() {
    this.property = this.getSelectedProperty;
    this.updatePerformanceData();
  }

  @Watch("selectedDates")
  public onDatesChanged() {
    this.updatePerformanceData();
  }

  @Watch("creativeOverview")
  public onOverviewChanged() {
    this.items = this.getPerformanceData;
  }

  @Watch("creativeEnquiriesLoaded")
  public onEnquiriesLoaded() {
    this.enquiriesLoaded = this.getEnquiriesLoaded;
  }

  public updatePerformanceData() {
    this.loading = true;
    this.enquiriesLoaded = false;
    if (this.property) {
      Promise.race([
        this.retrievePropertyTemplatePerformance(this.property.propertyId),
        this.retrieveCreativeEnquiryPerformance(this.property.propertyId)
      ]).then((result) => {
        if (result) {
          this.enquiriesLoaded = this.getEnquiriesLoaded;
          this.items = this.creativeOverview;
        }

        this.loading = false;
      });
    }
  }

  public created() {
    this.property = this.getSelectedProperty;
    this.updatePerformanceData();
  }
}
